"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactChartjs = require("react-chartjs-2");

var _reactSizeme = require("react-sizeme");

var _Flex = _interopRequireDefault(require("../../Flex/Flex"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

var _customHooks = _interopRequireDefault(require("../../../customHooks"));

var _utils = _interopRequireDefault(require("../../../utils"));

var _circleBackgroundPlugin = _interopRequireDefault(require("./circleBackgroundPlugin"));

var _excluded = ["percentage", "disableAllAnimation", "thicknessPercentage", "bgColor", "strokeColor", "graphOptions", "textProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Graph = function Graph(_ref) {
  var containerRef = _ref.containerRef,
      percentage = _ref.percentage,
      thicknessPercentage = _ref.thicknessPercentage,
      bgColor = _ref.bgColor,
      disableAllAnimation = _ref.disableAllAnimation,
      _ref$graphOptions = _ref.graphOptions,
      graphOptions = _ref$graphOptions === void 0 ? {} : _ref$graphOptions,
      strokeColor = _ref.strokeColor;

  var device = _customHooks["default"].useClientDevice();

  var indicatorVisible = _customHooks["default"].useElementVisibleTrigger({
    componentRef: containerRef,
    delay: 0
  });

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    position: "relative",
    height: "100%",
    width: "100%",
    className: "chart-container"
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Doughnut, {
    plugins: [_circleBackgroundPlugin["default"]],
    data: {
      datasets: [{
        data: [indicatorVisible || disableAllAnimation ? 360 / 100 * percentage : 0, indicatorVisible || disableAllAnimation ? 360 - 360 / 100 * percentage : 360],
        backgroundColor: [strokeColor, "rgba(0, 0, 0, 0)"]
      }]
    },
    options: _utils["default"].deepMerge({
      plugins: {
        legend: false,
        tooltip: false,
        circleBackground: {
          bgColor: bgColor,
          thicknessPercentage: thicknessPercentage
        }
      },
      hover: {
        mode: null
      },
      animation: disableAllAnimation ? false : {
        delay: 10,
        duration: 1000,
        easing: "easeOutBack"
      },
      backgroundColor: strokeColor,
      cutout: thicknessPercentage + "%",
      borderWidth: 0,
      maintainAspectRatio: true
    }, graphOptions),
    device: device
  }));
};
/**
 * A circle progress bar.
 *
 * To learn more about how to use this component, see examples within Storybook.
 *
 * @param {object} props React components passed in props
 * @param {number} [props.percentage] A percentage
 * @param {boolean} [props.disableAllAnimation] Disables animation
 * @param {number} [props.thicknessPercentage] A higher percentage, the thinner the bar becomes
 * @param {string} [props.bgColor] This is the background of the progress bar
 * @param {string} [props.strokeColor] Colour of progress bar
 * @param {object} [props.graphOptions] Can add / override options passed into chart.js doughnut
 * @param {object} [props.textProps] Props to pass into the center text
 */


var CircularProgress = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage,
      disableAllAnimation = _ref2.disableAllAnimation,
      _ref2$thicknessPercen = _ref2.thicknessPercentage,
      thicknessPercentage = _ref2$thicknessPercen === void 0 ? 85 : _ref2$thicknessPercen,
      _ref2$bgColor = _ref2.bgColor,
      bgColor = _ref2$bgColor === void 0 ? "#d9d9d9" : _ref2$bgColor,
      _ref2$strokeColor = _ref2.strokeColor,
      strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
      graphOptions = _ref2.graphOptions,
      textProps = _ref2.textProps,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
  var containerRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    ref: containerRef,
    height: "auto",
    width: "100%",
    flexDirection: "column",
    position: "relative",
    alignItems: "center",
    justifyContent: "center"
  }, props), /*#__PURE__*/_react["default"].createElement(Graph, {
    percentage: percentage,
    thicknessPercentage: thicknessPercentage,
    strokeColor: strokeColor,
    graphOptions: graphOptions,
    disableAllAnimation: disableAllAnimation,
    containerRef: containerRef,
    bgColor: bgColor
  }), /*#__PURE__*/_react["default"].createElement(_reactSizeme.SizeMe, {
    monitorHeight: true
  }, function (_ref3) {
    var size = _ref3.size;
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
      position: "absolute",
      style: {
        textAlign: "center"
      },
      top: "calc(50% - " + size.height / 2 + "px)",
      width: "100%",
      fontSize: size.width / 4 + "px",
      color: "#666666",
      fontWeight: 700,
      noSelect: true
    }, textProps), percentage, "%");
  }));
}, _utils["default"].areEqual);

var _default = CircularProgress;
exports["default"] = _default;